import { useState } from "react";

const points = [
  {
    id: 1,
    title: "ADHD is a Developmental Delay",
    emoji: "🌱",
    color: "#FFF0D6",
    accent: "#FF9A3C",
    illustration: "🐢➡️🐇",
    scene: ["🌿", "🐢", "🌸", "🐇", "⭐"],
    story: "Some kids grow at a slower pace — like a turtle taking a different path to the same destination. That's totally okay! They get there, just on their own timeline.",
    tip: "Everyone blooms in their own time! 🌸"
  },
  {
    id: 2,
    title: "More vs. Less — Not Different",
    emoji: "📏",
    color: "#E8F4FF",
    accent: "#4A90D9",
    illustration: "📏🧒👦",
    scene: ["📊", "🧒", "👦", "📏", "💫"],
    story: "ADHD isn't a superpower or alien brain — it's just having MORE wiggles and LESS focus than other kids. Like some kids are taller and some are shorter!",
    tip: "We're all on the same team, just different sizes! 🏅"
  },
  {
    id: 3,
    title: "It Lasts a Long Time",
    emoji: "⏳",
    color: "#F0FFE8",
    accent: "#5CB85C",
    illustration: "⏳🌈",
    scene: ["☀️", "🌤️", "🌧️", "🌈", "⭐"],
    story: "ADHD doesn't disappear after a week or a year. It stays for a long time — but with help and practice, things get easier and easier every day!",
    tip: "Like learning to ride a bike — it takes time but you get it! 🚲"
  },
  {
    id: 4,
    title: "The 'Stop' Button is Hard to Press",
    emoji: "🛑",
    color: "#FFF0F0",
    accent: "#E74C3C",
    illustration: "🚂💨🛑",
    scene: ["🚂", "💨", "💨", "🛑", "⚡"],
    story: "Imagine a train going really fast and the brakes are sticky! Kids with ADHD have a tricky 'stop' button in their brain — it's harder to slow down quick actions.",
    tip: "Practice makes the brakes stronger! 🛑"
  },
  {
    id: 5,
    title: "Too Much Energy!",
    emoji: "⚡",
    color: "#FFFBE0",
    accent: "#F1C40F",
    illustration: "⚡🏃💨",
    scene: ["⚡", "🏃", "💨", "🪑", "😅"],
    story: "Moving, talking, jumping — it's like having a motor that won't turn off! This extra energy is hard to hold inside, so it comes out as wiggles and words.",
    tip: "Let's find good places to use that energy! ⚡"
  },
  {
    id: 6,
    title: "Acting Before Thinking",
    emoji: "💭",
    color: "#F5E6FF",
    accent: "#9B59B6",
    illustration: "🤔💡✋",
    scene: ["💭", "⁉️", "✋", "💡", "😊"],
    story: "Sometimes the brain hits 'go' before it has time to think! Like answering a question before you even hear all of it. A little pause helps a lot!",
    tip: "Count to 3 before you zoom! 1️⃣2️⃣3️⃣"
  },
  {
    id: 7,
    title: "Big Feelings Happen Fast",
    emoji: "🌊",
    color: "#E0F7FF",
    accent: "#00BCD4",
    illustration: "😊➡️😡🌊",
    scene: ["😊", "😠", "🌊", "😤", "🌈"],
    story: "Feelings can go from calm to HUGE really quickly — like a wave crashing! It's not bad feelings, just fast feelings that are hard to slow down.",
    tip: "Take a deep breath to ride the wave! 🌊"
  },
  {
    id: 8,
    title: "Big Feelings Scare Friends Away",
    emoji: "👫",
    color: "#FFF5E6",
    accent: "#FF7043",
    illustration: "😠👫💔",
    scene: ["👦", "😤", "👧", "💔", "🤝"],
    story: "When feelings get TOO big, friends might feel scared or hurt. Learning to calm the big feelings helps friendships grow stronger and last longer!",
    tip: "Friends love calm and kind! 🤝"
  },
  {
    id: 9,
    title: "Hard to Keep Going on Boring Tasks",
    emoji: "😴",
    color: "#F0FFF4",
    accent: "#27AE60",
    illustration: "📚😴⭐",
    scene: ["📚", "😴", "💤", "⭐", "🎮"],
    story: "Staying focused on something NOT fun is really hard — like the brain needs a yummy treat to keep going! Fun things are easy; boring ones need extra help.",
    tip: "Make it fun and you'll stay on! 🎉"
  },
  {
    id: 10,
    title: "ADHD = Self-Control Superchallenge",
    emoji: "🎮",
    color: "#EEF2FF",
    accent: "#5C6BC0",
    illustration: "🎮🧠💪",
    scene: ["🧠", "🎮", "⚙️", "💪", "🌟"],
    story: "ADHD is really about the brain's self-control system being on a harder level. It's not about being bad — the brain's control center just needs more support!",
    tip: "You're playing on hard mode — that's brave! 🎮"
  },
  {
    id: 11,
    title: "Self-Control = Pausing First",
    emoji: "⏸️",
    color: "#FFF9E0",
    accent: "#FFB300",
    illustration: "⏸️🧠✨",
    scene: ["💥", "⏸️", "🤔", "💡", "✅"],
    story: "Self-control starts with one powerful move: PAUSE! When you stop before doing something, your brain gets a moment to choose the best action.",
    tip: "Pause = power! ⏸️"
  },
  {
    id: 12,
    title: "The Thinking Gap",
    emoji: "🧩",
    color: "#F0FAFF",
    accent: "#0288D1",
    illustration: "💬🧩🔧",
    scene: ["💬", "🕳️", "🧩", "🔧", "💡"],
    story: "Between an event and what you do next, there's a tiny gap for thinking. Kids with ADHD have a smaller gap, so thoughts and plans get squeezed out!",
    tip: "We can make that gap bigger with practice! 🧩"
  },
  {
    id: 13,
    title: "Knowing vs. Doing",
    emoji: "✅",
    color: "#FFF0FA",
    accent: "#E91E8C",
    illustration: "📖✅🏃",
    scene: ["📖", "💡", "🏃", "❌", "🤷"],
    story: "Kids with ADHD often KNOW the rules perfectly — but in the moment, their brain forgets to use that knowledge! Knowing and doing are two totally different things.",
    tip: "Reminders at the right moment save the day! 📌"
  },
  {
    id: 14,
    title: "Tiny Mental Chalkboard",
    emoji: "🖊️",
    color: "#E8FFE8",
    accent: "#388E3C",
    illustration: "🖊️🗒️✏️",
    scene: ["🖊️", "🗒️", "✏️", "🧽", "❓"],
    story: "Working memory is like a brain chalkboard. For kids with ADHD, it's extra small and gets erased quickly — so they forget what they were doing mid-way!",
    tip: "Write it down before it's gone! 📝"
  },
  {
    id: 15,
    title: "Learning to Use an Inner Voice",
    emoji: "💬",
    color: "#FFF8E1",
    accent: "#FB8C00",
    illustration: "💬🧠🗣️",
    scene: ["🗣️", "💬", "🧠", "🤫", "✨"],
    story: "Most kids grow a quiet inside-voice that whispers instructions. Kids with ADHD develop this voice later, so they may talk out loud to think — that's okay!",
    tip: "Talking it out is totally valid! 🗣️"
  },
  {
    id: 16,
    title: "Running Out of 'Want-To' Fuel",
    emoji: "⛽",
    color: "#FFF3E0",
    accent: "#EF6C00",
    illustration: "⛽🚗😅",
    scene: ["⛽", "🚗", "💨", "😴", "🏁"],
    story: "Even when kids WANT to finish something, the brain can run out of 'go-go-go' fuel if the task isn't exciting. It's like a car running on empty — not lazy, just empty!",
    tip: "Refuel with small rewards along the way! 🎁"
  },
  {
    id: 17,
    title: "Need Helpers from the Outside",
    emoji: "🌟",
    color: "#F3E5FF",
    accent: "#7B1FA2",
    illustration: "🌟👨‍👩‍👧🤝",
    scene: ["👦", "💫", "👩‍🏫", "🤝", "⭐"],
    story: "Kids with ADHD need cheerleaders, reminders, and reward systems from around them. The outside world becomes their fuel station!",
    tip: "It takes a team and that's great! 🌟"
  },
  {
    id: 18,
    title: "Time Feels Invisible",
    emoji: "⏰",
    color: "#E0F2F1",
    accent: "#00897B",
    illustration: "⏰👻💨",
    scene: ["⏰", "👻", "💨", "📆", "😲"],
    story: "Time can feel invisible to kids with ADHD. '10 minutes' doesn't feel real until it's gone. They live in a big NOW with no past or future — just this moment!",
    tip: "Clocks and timers make time visible! ⏱️"
  },
  {
    id: 19,
    title: "Hard to Picture 'Later'",
    emoji: "🔮",
    color: "#EDE7F6",
    accent: "#512DA8",
    illustration: "🔮🌫️📅",
    scene: ["🔮", "🌫️", "📅", "🤔", "❓"],
    story: "Planning for the future is like trying to see through fog! Kids with ADHD struggle to picture what's coming, so preparing ahead feels impossible.",
    tip: "Calendars and pictures bring the future closer! 📅"
  },
  {
    id: 20,
    title: "Hard to Calm Feelings Down",
    emoji: "🌡️",
    color: "#FFEBEE",
    accent: "#C62828",
    illustration: "🌡️😤❄️",
    scene: ["😤", "🌡️", "❄️", "😤", "😌"],
    story: "Once feelings start rising, hitting the brakes is really hard. The emotional engine runs hot and keeps going even after the thing that started it is done!",
    tip: "Cool-down tools help! Ice, water, slow breaths 💧"
  },
  {
    id: 21,
    title: "Help Must Happen RIGHT NOW",
    emoji: "📍",
    color: "#E8F5E9",
    accent: "#2E7D32",
    illustration: "📍⚡🎯",
    scene: ["📍", "⚡", "🎯", "✅", "🌟"],
    story: "Rules talked about at dinner won't help on the playground next day. The reminder, reward, or help needs to happen RIGHT at the moment it's needed — not before, not after!",
    tip: "Right here, right now is where it counts! 📍"
  },
  {
    id: 22,
    title: "Put Info in the World",
    emoji: "📋",
    color: "#FFF8E1",
    accent: "#F57F17",
    illustration: "📋🗒️📌",
    scene: ["🧠", "📋", "📌", "🗒️", "✅"],
    story: "Since the mental chalkboard is small, write things on REAL paper! Checklists, sticky notes, and signs help the brain by putting the info in the world where eyes can see it.",
    tip: "Sticky notes are brain boosters! 📌"
  },
  {
    id: 23,
    title: "Make Time Something You Can See",
    emoji: "🏖️",
    color: "#E1F5FE",
    accent: "#0277BD",
    illustration: "⏱️👁️🟥",
    scene: ["⏱️", "👁️", "🟥", "🔴", "✅"],
    story: "Use a timer with a moving red section or a big sand hourglass! When you can SEE time shrinking, it stops being invisible and starts being real!",
    tip: "Visual timers are magic! ⏱️🔴"
  },
  {
    id: 24,
    title: "Rewards Need to Come Fast!",
    emoji: "🎁",
    color: "#FCE4EC",
    accent: "#AD1457",
    illustration: "✅🎁⚡",
    scene: ["✅", "⚡", "🎁", "😄", "⭐"],
    story: "Waiting a whole week for a prize is too long for an ADHD brain. Give small, immediate rewards right away — stickers, high-fives, a little treat — as soon as the good thing happens!",
    tip: "Fast rewards = big results! 🎁"
  },
  {
    id: 25,
    title: "Build a Helper World",
    emoji: "🏗️",
    color: "#F1F8E9",
    accent: "#558B2F",
    illustration: "🏗️🛠️🌍",
    scene: ["🏗️", "🛠️", "🌍", "♿", "⭐"],
    story: "Like ramps help wheelchair users, we can build a helpful world for kids with ADHD — checklists, routines, reminders everywhere. Change the environment, not just the child!",
    tip: "Build the world around their needs! 🏗️"
  },
  {
    id: 26,
    title: "ADHD and Bipolar Are Different",
    emoji: "🔬",
    color: "#E8EAF6",
    accent: "#3949AB",
    illustration: "🔬🧬❌🔄",
    scene: ["🔬", "🧬", "❌", "🔄", "💡"],
    story: "Some people mix up ADHD with Bipolar, but they're different! Having ADHD doesn't mean you'll get Bipolar. Each one has its own path and its own type of help.",
    tip: "Different conditions = different support! 🔬"
  },
  {
    id: 27,
    title: "Family Patterns Matter",
    emoji: "👨‍👩‍👧‍👦",
    color: "#FFF3E0",
    accent: "#E65100",
    illustration: "👨‍👩‍👧‍👦🧬🌳",
    scene: ["👨‍👩‍👧‍👦", "🧬", "🌳", "💛", "🤝"],
    story: "Sometimes mood challenges run in families. If a parent or sibling has big mood swings along with ADHD, doctors look at the whole family tree to give the best help.",
    tip: "Knowing your family story helps doctors help YOU! 🌳"
  },
  {
    id: 28,
    title: "Medicine Can Really Help",
    emoji: "💊",
    color: "#E0F7FA",
    accent: "#006064",
    illustration: "💊🧠✨",
    scene: ["💊", "🧠", "✨", "📊", "💪"],
    story: "Medicine for ADHD is very well studied — hundreds of studies show it really works for most kids! It helps the brain's control center work better. It's not magic, but it's mighty helpful!",
    tip: "Medicine is a tool, not a weakness! 💊"
  },
  {
    id: 29,
    title: "Sometimes More Than One Medicine",
    emoji: "🧪",
    color: "#F3E5F5",
    accent: "#6A1B9A",
    illustration: "🧪⚗️👨‍⚕️",
    scene: ["🧪", "⚗️", "👨‍⚕️", "📋", "💙"],
    story: "When kids have ADHD AND another condition, doctors might need more than one medicine. It's like needing two keys to open two locks — and the doctor keeps everything safe.",
    tip: "Doctors are the expert helpers here! 👨‍⚕️"
  },
  {
    id: 30,
    title: "It's a Long Journey — Keep Going!",
    emoji: "🏆",
    color: "#FFFDE7",
    accent: "#F9A825",
    illustration: "🏆🛤️⭐",
    scene: ["🛤️", "👦", "🌟", "🏆", "🎉"],
    story: "Managing ADHD is a long journey, not a one-time fix. Parents and kids work together for years — building skills, routines, and confidence step by step. The finish line is a great life!",
    tip: "Every small step counts! You've got this! 🏆"
  }
];

const partLabels = [
  { range: [1, 10], label: "Part 1: Understanding ADHD", color: "#FF9A3C" },
  { range: [11, 20], label: "Part 2: The Brain's Control Center", color: "#5C6BC0" },
  { range: [21, 30], label: "Part 3: Helping & Managing", color: "#27AE60" }
];

function PointCard({ point, index }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      onClick={() => setFlipped(!flipped)}
      style={{
        cursor: "pointer",
        perspective: "1000px",
        height: "320px",
        width: "100%",
      }}
    >
      <div style={{
        position: "relative",
        width: "100%",
        height: "100%",
        transformStyle: "preserve-3d",
        transition: "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
        transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)"
      }}>
        {/* Front */}
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backfaceVisibility: "hidden",
          WebkitBackfaceVisibility: "hidden",
          background: point.color,
          borderRadius: "24px",
          border: `3px solid ${point.accent}`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          boxSizing: "border-box",
          boxShadow: `0 8px 24px ${point.accent}30`,
          overflow: "hidden"
        }}>
          {/* Background decorative circles */}
          <div style={{
            position: "absolute",
            width: "120px",
            height: "120px",
            borderRadius: "50%",
            background: `${point.accent}15`,
            top: "-20px",
            right: "-20px"
          }} />
          <div style={{
            position: "absolute",
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: `${point.accent}10`,
            bottom: "10px",
            left: "-10px"
          }} />

          {/* Number badge */}
          <div style={{
            position: "absolute",
            top: "14px",
            left: "14px",
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            background: point.accent,
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "900",
            fontSize: "14px",
            fontFamily: "'Fredoka One', cursive"
          }}>
            {point.id}
          </div>

          {/* Main emoji */}
          <div style={{ fontSize: "64px", marginBottom: "8px", filter: "drop-shadow(2px 4px 6px rgba(0,0,0,0.15))" }}>
            {point.emoji}
          </div>

          {/* Scene emojis */}
          <div style={{
            display: "flex",
            gap: "8px",
            fontSize: "24px",
            marginBottom: "14px",
            background: "white",
            borderRadius: "30px",
            padding: "8px 16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
          }}>
            {point.scene.map((e, i) => (
              <span key={i} style={{ 
                animation: `bounce ${0.6 + i * 0.15}s ease infinite alternate`,
                display: "inline-block"
              }}>{e}</span>
            ))}
          </div>

          {/* Title */}
          <h3 style={{
            fontFamily: "'Fredoka One', cursive",
            fontSize: "17px",
            color: point.accent,
            textAlign: "center",
            margin: "0 0 10px 0",
            lineHeight: 1.2
          }}>
            {point.title}
          </h3>

          {/* Tap hint */}
          <div style={{
            position: "absolute",
            bottom: "12px",
            right: "14px",
            fontSize: "11px",
            color: `${point.accent}99`,
            fontFamily: "'Nunito', sans-serif",
            fontWeight: "700"
          }}>
            Tap to read! 👆
          </div>
        </div>

        {/* Back */}
        <div style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backfaceVisibility: "hidden",
          WebkitBackfaceVisibility: "hidden",
          transform: "rotateY(180deg)",
          background: `linear-gradient(135deg, ${point.accent}22 0%, ${point.color} 100%)`,
          borderRadius: "24px",
          border: `3px solid ${point.accent}`,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "22px",
          boxSizing: "border-box",
          boxShadow: `0 8px 24px ${point.accent}30`,
        }}>
          <div style={{ fontSize: "36px", marginBottom: "10px" }}>{point.emoji}</div>
          <p style={{
            fontFamily: "'Nunito', sans-serif",
            fontSize: "14px",
            color: "#444",
            textAlign: "center",
            lineHeight: 1.6,
            margin: "0 0 14px 0",
            fontWeight: "700"
          }}>
            {point.story}
          </p>
          <div style={{
            background: point.accent,
            borderRadius: "16px",
            padding: "8px 16px",
            color: "white",
            fontFamily: "'Fredoka One', cursive",
            fontSize: "13px",
            textAlign: "center"
          }}>
            {point.tip}
          </div>
          <div style={{
            position: "absolute",
            bottom: "12px",
            right: "14px",
            fontSize: "11px",
            color: `${point.accent}99`,
            fontFamily: "'Nunito', sans-serif",
            fontWeight: "700"
          }}>
            Tap to flip back! 🔄
          </div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [activeFilter, setActiveFilter] = useState("all");

  const filteredPoints = activeFilter === "all" 
    ? points 
    : points.filter(p => {
        const part = partLabels.find(pl => p.id >= pl.range[0] && p.id <= pl.range[1]);
        return part && part.label === activeFilter;
      });

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fredoka+One&family=Nunito:wght@400;700;900&display=swap');
        
        @keyframes bounce {
          from { transform: translateY(0px); }
          to { transform: translateY(-4px); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(-2deg); }
          50% { transform: translateY(-12px) rotate(2deg); }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        body { margin: 0; }
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 8px; }
        ::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
        ::-webkit-scrollbar-thumb { background: #FFB300; border-radius: 10px; }
      `}</style>

      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg, #FFF9F0 0%, #F0F8FF 50%, #F5F0FF 100%)",
        fontFamily: "'Nunito', sans-serif",
        padding: "0 0 60px 0"
      }}>
        {/* Header */}
        <div style={{
          textAlign: "center",
          padding: "40px 20px 30px",
          position: "relative",
          overflow: "hidden"
        }}>
          {/* Decorative emojis */}
          {["🧠","⭐","🎯","💡","🌈","🎉","🏆","💪"].map((e, i) => (
            <div key={i} style={{
              position: "absolute",
              fontSize: `${20 + (i % 3) * 8}px`,
              top: `${10 + (i % 3) * 20}%`,
              left: i < 4 ? `${3 + i * 6}%` : undefined,
              right: i >= 4 ? `${3 + (i - 4) * 6}%` : undefined,
              animation: `float ${2 + i * 0.3}s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
              opacity: 0.7
            }}>{e}</div>
          ))}

          <div style={{
            display: "inline-block",
            background: "linear-gradient(90deg, #FF9A3C, #E91E8C, #5C6BC0, #27AE60, #FF9A3C)",
            backgroundSize: "200% auto",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            animation: "shimmer 3s linear infinite",
            fontFamily: "'Fredoka One', cursive",
            fontSize: "clamp(28px, 5vw, 52px)",
            lineHeight: 1.1,
            marginBottom: "8px"
          }}>
            🧠 Understanding ADHD
          </div>
          <div style={{
            fontFamily: "'Fredoka One', cursive",
            fontSize: "clamp(14px, 2.5vw, 20px)",
            color: "#888",
            marginBottom: "6px"
          }}>
            30 Big Ideas — Made Simple for Kids & Families
          </div>
          <div style={{
            display: "inline-block",
            background: "#FFF0D6",
            borderRadius: "20px",
            padding: "6px 18px",
            fontSize: "13px",
            color: "#FF9A3C",
            fontWeight: "900",
            border: "2px solid #FF9A3C"
          }}>
            👆 Tap each card to learn more!
          </div>
        </div>

        {/* Filter buttons */}
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          justifyContent: "center",
          padding: "0 20px 30px"
        }}>
          {[{label: "all", display: "🌟 All 30 Points", color: "#888"}, ...partLabels.map(p => ({label: p.label, display: p.label, color: p.color}))].map(f => (
            <button
              key={f.label}
              onClick={() => setActiveFilter(f.label)}
              style={{
                background: activeFilter === f.label ? f.color : "white",
                color: activeFilter === f.label ? "white" : f.color,
                border: `2px solid ${f.color}`,
                borderRadius: "20px",
                padding: "8px 18px",
                fontFamily: "'Fredoka One', cursive",
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.2s",
                boxShadow: activeFilter === f.label ? `0 4px 12px ${f.color}50` : "none"
              }}
            >
              {f.display}
            </button>
          ))}
        </div>

        {/* Cards grid */}
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "24px"
        }}>
          {filteredPoints.map((point, idx) => (
            <PointCard key={point.id} point={point} index={idx} />
          ))}
        </div>

        {/* Footer */}
        <div style={{
          textAlign: "center",
          marginTop: "50px",
          padding: "20px",
          fontFamily: "'Fredoka One', cursive",
          fontSize: "16px",
          color: "#aaa"
        }}>
          Based on Dr. Russell Barkley's 30 Touchstone Ideas 🎓<br/>
          <span style={{ fontSize: "12px", fontFamily: "'Nunito', sans-serif", fontWeight: "700" }}>
            Made with ❤️ to help kids and families understand ADHD
          </span>
        </div>
      </div>
    </>
  );
}
